import { render, staticRenderFns } from "./DistributeWeights.vue?vue&type=template&id=446bb466&scoped=true"
import script from "./DistributeWeights.vue?vue&type=script&lang=ts"
export * from "./DistributeWeights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446bb466",
  null
  
)

export default component.exports